<template>
    <div class="wrapp">
        <div class="bg"></div>
    </div>
</template>

<script>
    export default {
        name: "404"
    }
</script>

<style scoped>

</style>